<template>
  <q-layout>
    <q-page-container>
      <q-page class="q-pa-lg">
        <h3 class="text-center">{{ $t('login.login') }}</h3>
        <div class="row justify-center">
          <form @submit.prevent="onSubmit" class="col col-lg-4">
            <q-field>
              <q-input v-model.lazy.trim="username" :error="!!error" type="text" :float-label="$t('login.username')"/>
            </q-field>
            <q-field class="q-mb-lg">
              <q-input ref="pwd" v-model.lazy.trim="password" :error="!!error" type="password" :float-label="$t('login.password')"/>
            </q-field>
            <div v-if="this.error" class="text-negative q-mb-lg">{{ error }}</div>
            <q-btn size="lg" color="primary" type="submit" class="full-width">{{ $t('login.submit') }}</q-btn>
          </form>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
export default {
  data () {
    return {
      error: null,
      username: '',
      password: ''
    }
  },
  methods: {
    onSubmit () {
      const { username, password } = this
      this.$q.loading.show()
      this.$store.dispatch('login', { username, password })
        .catch(e => {
          this.error = this.$t('login.invalid_login')
        })
        .then(() => {
          this.$q.loading.hide()

          this.$router.push('/')
        })
    }
  },
  meta () {
    // Quasar meta plugin sets document title
    return {
      title: this.$t('login.submit')
    }
  }
}
</script>
